<template>
    <div>
        <div shadow="never" class="filter-form">
            <el-row :gutter="20" >
                <el-col :span="4">
                    <label class="label">
                        {{ $t('name') }}
                    </label>
                    <el-input v-model="c.q"></el-input>
                </el-col>
                <el-col :span="4">
                    <label class="label">
                        {{ $t('category') }}
                    </label>
                    <el-select v-model="c.categoryIDs" :placeholder="$t('all')" multiple filterable style="width: 100%;">
                        <el-option
                                v-for="item in categories"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="4">
                    <label class="label">
                        {{ $t('country') }}
                    </label>
                    <el-select v-model="c.countryIDs" :placeholder="$t('all')" multiple filterable style="width: 100%">
                        <el-option
                                v-for="item in countries"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            <span class="m-r-xs flag-icon" :class="'flag-icon-' + item.id | lowercase"></span> {{item.name}}
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="4">
                    <el-button type="primary" @click="search" icon="el-icon-search">{{ $t('search') }}</el-button>
                </el-col>
            </el-row>
        </div>

        <el-table
                v-loading="loading"
                :data="offers"
                style="width: 100%">
            <div slot="empty">
                <span v-if="!loading">{{ $t('el.table.emptyText') }}</span>
            </div>

            <el-table-column
                    prop="logo"
                    width="130"
            >
                <template slot-scope="scope">
                    <router-link :to="{name: 'offer-view', params: { id: scope.row.id }}" class="offer-name">
                        <img :src="scope.row.logo" style="max-width: 100%;">
                    </router-link>
                </template>
            </el-table-column>

            <el-table-column
                    prop="name"
                    :label="$t('name')">
                <template slot-scope="scope">
                    <router-link :to="{name: 'offer-view', params: { id: scope.row.id }}" class="offer-name">
                        {{scope.row.name}}
                    </router-link>
                    <a class="text-muted" :href="scope.row.preview_url" target="_blank" v-if="scope.row.preview_url"><i class="material-icons md-24">&#xe8f4;</i></a>
                    <div style="margin-top: 5px;">
                        <router-link :to="{name: 'offer-view', params: { id: scope.row.id }}" class="offer-name">
                            <el-button type="primary" size="mini" v-if="scope.row.status==='active'">{{ $t('create_stream') }}</el-button>
                            <el-button type="primary" size="mini" v-if="scope.row.status==='required_approval'">{{ $t('request_access') }}</el-button>
                        </router-link>
                    </div>
                </template>
            </el-table-column>

            <el-table-column
                    prop="offer_payment"
                    :label="$t('payout')">
                <template slot-scope="scope">
                    <div v-for="action in limitBy(orderBy(scope.row.actions, 'payouts', -1), 1)" :key="action.id" class="goal">
                        <div v-if="action.payment_type==='fixed'">{{action.goal.name}} - {{ action.payouts | n(2, scope.row.currency.symbol) }}</div>
                      <div v-if="action.payment_type==='percent'">{{action.goal.name}}</div>

                        <div class="description">{{action.description}}</div>
                    </div>
                </template>
            </el-table-column>

            <el-table-column
                    prop="geo"
                    :label="$t('geo')">
                <template slot-scope="scope">
                    <div v-for="country in limitBy(scope.row.countries, 5)" :key="country.id">
                        <span class="flag-icon" :class="'flag-icon-' + country.id | lowercase"></span> {{ country.name}}
                    </div>
                    <el-popover
                            v-if="scope.row.countries.length > 5"
                            placement="right"
                            width="250"
                            trigger="click">
                        <div style="max-height: 400px; overflow: auto">
                            <div v-for="country in scope.row.countries" :key="country.id">
                                <span class="flag-icon" :class="'flag-icon-' + country.id | lowercase"></span> {{ country.name}}
                            </div>
                        </div>
                        <el-button slot="reference" type="text">...</el-button>
                    </el-popover>

                    <span v-if="!scope.row.countries.length">{{ $t('all_countries') }}</span>
                </template>
            </el-table-column>

            <el-table-column
                    prop="category"
                    :label="$t('category')">
                <template slot-scope="scope">
                    <div v-for="category in scope.row.categories" :key="category.id">
                        {{ (category.locale || category).name }}
                    </div>
                </template>
            </el-table-column>
        </el-table>

        <div class="pagination">
            <el-pagination
                    background
                    layout="prev, pager, next"
                    @current-change="handleCurrentChange"
                    :current-page="page"
                    :page-count="total_pages">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import qs from 'qs'

    export default {
        name: "Offer",
        data () {
            return {
                offers: [],
                page: 1,
                total_pages: 0,
                loading: true,
                categories: [],
                countries: [],
                c: {}
            };
        },
        created () {
            this.getOffers();

            this.$axios.get('/categories').then((res) => {
                this.categories = res.data;
            });

            this.$axios.get('/countries').then((res) => {
                this.countries = res.data;
            })
        },
        watch: {
            '$i18n.locale': {
                handler () {
                    this.getOffers()
                },
                deep: true
            },
            c: {
                handler () {
                    this.getOffers();
                },
                deep: true
            }
        },
        methods: {
            getOffers () {
                this.loading = true;
                this.$axios.get('/offers?' + qs.stringify({ expand: 'sources,countries,categories,landings,actions', page: this.page, 'per-page': '25', c: this.c }, { encode: false })).then((res) => {
                    this.offers = res.data;
                    this.total_pages = parseInt(res.headers['x-pagination-page-count']);
                    this.loading = false;
                })
            },
            handleCurrentChange(val) {
                this.page = val;
                this.getOffers()
            },
            search() {
                this.page = 1;
                this.getOffers()
            }
        }
    }
</script>

<style lang="scss" scoped>
    .el-table {
        margin-top:15px;
    }

    .goal {
        .description {
            font-size: 13px;
            color: #898989;
        }
    }

    .countries {
        .flag-icon {
            margin-right: 3px;
        }
    }

    .fa {
        margin-left: 3px;
    }

    .offer-name {
        .logo {
            height: 60px;
        }
    }
</style>